import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=96043306&"
import script from "./Experience.vue?vue&type=script&lang=ts&"
export * from "./Experience.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports